import React, {useState} from 'react'
import { CardElement, useStripe, useElements } from '@stripe/react-stripe-js';

const CheckoutForm = () => {
  const stripe = useStripe();
  const elements = useElements();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleSubmit = () =>{
     console.log('hello')
  }

  return (
    <div className="container mt-5">
    <div className="card">
      <div className="card-header text-center bg-primary text-white">
        Payment Form
      </div>
      <div className="card-body">
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="card-element" className="form-label">Credit or Debit Card</label>
            <div className="card-element-container">
              <CardElement id="card-element" className="form-control" />
            </div>
          </div>

          {/* {error && <div className="alert alert-danger">{error}</div>} */}

          <button type="submit" className="btn btn-primary w-100" disabled={!stripe || isProcessing}>
            {isProcessing ? (
              <div className="spinner-border text-light spinner-border-sm" role="status">
                <span className="visually-hidden">Processing...</span>
              </div>
            ) : (
              'Pay'
            )}
          </button>
        </form>
      </div>
    </div>
  </div>
  )
}

export default CheckoutForm